import { Hub } from "aws-amplify/utils";
import { EVENTS, handleOAuthStateRedirect } from "../../util/hub";
import { clearUserData, setRedirectPath } from "../../services/authorization/slices";
import { syncAmplifyReduxUserAttributes } from "../../services/authorization/thunks";

export const createAmplifyMiddleware = ({ dispatch }) => {
  let hubListener = null;
  const setupListener = () => {
    if (!hubListener) {
      hubListener = Hub.listen("auth", async (data) => {
        const {
          payload: { event },
        } = data;

        if (event === EVENTS.customOAuthState) {
          const redirectPath = handleOAuthStateRedirect(data?.payload);
          dispatch(setRedirectPath(redirectPath));
        }
        if (event === EVENTS.signedIn) {
          dispatch(syncAmplifyReduxUserAttributes())
        }
        if (event === EVENTS.signOut) {
          dispatch(clearUserData());
        }
      });
    }
  };

  setupListener();

  return (next) => (action) => {
    if (!hubListener) {
      setupListener();
    }
    return next(action);
  };
};
